export default "__VITE_ASSET__BsSwrlXf__"